<template>
    <div class="modals">
        <div class="modals-inner">
            <h2 class="modals-inner-title">დეკლარირება</h2>
            <button class="modals-inner-closer" @click="onClose">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12.121"
                    height="12.121"
                    viewBox="0 0 12.121 12.121"
                >
                    <g
                        id="close-circle"
                        transform="translate(-244.109 -260.109)"
                    >
                        <path
                            id="Vector"
                            d="M0,10,10,0"
                            transform="translate(245.17 261.17)"
                            fill="none"
                            stroke="#12202b"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                        <path
                            id="Vector-2"
                            data-name="Vector"
                            d="M10,10,0,0"
                            transform="translate(245.17 261.17)"
                            fill="none"
                            stroke="#12202b"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="1.5"
                        />
                    </g>
                </svg>
            </button>

            <div class="modals-content">
                <div class="item-info">
                    <div class="icon">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M3.17004 7.43994L12 12.5499L20.77 7.46991"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M12 21.6099V12.5399"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M9.92999 2.48L4.59 5.45003C3.38 6.12003 2.39001 7.80001 2.39001 9.18001V14.83C2.39001 16.21 3.38 17.89 4.59 18.56L9.92999 21.53C11.07 22.16 12.94 22.16 14.08 21.53L19.42 18.56C20.63 17.89 21.62 16.21 21.62 14.83V9.18001C21.62 7.80001 20.63 6.12003 19.42 5.45003L14.08 2.48C12.93 1.84 11.07 1.84 9.92999 2.48Z"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                            <path
                                d="M17 13.24V9.58002L7.51001 4.09998"
                                stroke="#fff"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></path>
                        </svg>
                    </div>
                    <div class="name">
                        <span>თრექინგი</span>
                        <p>{{ this.parcel.tracking_number }}</p>
                    </div>
                </div>
                <!-- <div class="w-100">
                    <h2 class="gender-title">ამანათი</h2>
                    <div class="gender">
                        <label
                            :for="`onlineShop-${props.parcel.tracking_number}`"
                        >
                            <input
                                type="radio"
                                :name="`types-${props.parcel.tracking_number}`"
                                :id="
                                    `onlineShop-${props.parcel.tracking_number}`
                                "
                                :value="`1-${props.parcel.tracking_number}`"
                                v-model="parcelType"
                                :checked="
                                    parcelType ==
                                        `1-${props.parcel.tracking_number}`
                                "
                                :disabled="
                                    props.parcel.declaration && pageId == 3
                                "
                            />

                            <div class="box"></div>
                            <span>ონლაინ მაღაზია</span>
                        </label>
                        <label
                            :for="
                                `PrivateMessage-${props.parcel.tracking_number}`
                            "
                            class="m-0"
                        >
                            <input
                                type="radio"
                                :name="`types-${props.parcel.tracking_number}`"
                                :id="
                                    `PrivateMessage-${props.parcel.tracking_number}`
                                "
                                :value="`2-${props.parcel.tracking_number}`"
                                v-model="parcelType"
                                :checked="
                                    parcelType ==
                                        `2-${props.parcel.tracking_number}`
                                "
                                :disabled="
                                    props.parcel.declaration && pageId == 3
                                "
                            />
                            <div class="box"></div>
                            <span>პირადი გზავნილი</span>
                        </label>
                    </div>
                </div> -->

                <ValidationObserver ref="observer">
                    <ValidationProvider
                        v-slot="{ errors }"
                        rules="required"
                        tag="div"
                    >
                        <div
                            :class="{
                                'select-input': true,
                                'is-invalid': errors[0] ? true : false,
                            }"
                        >
                            <select
                                name="markets"
                                class="markets"
                                v-model="market"
                                :disabled="parcel.declaration && pageId == 3"
                            >
                                <option></option>
                                <option
                                    v-for="(item, index) in props.markets"
                                    :key="index"
                                    :value="item.id"
                                >
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                        <span
                            v-if="errors[0]"
                            class="invalid-feedback"
                            role="alert"
                        >
                            <strong>{{ errors[0] }}</strong>
                        </span>
                    </ValidationProvider>
                </ValidationObserver>

                <declarationItems
                    :id="parcel.id"
                    :parcel="parcel"
                    :country="this.country"
                    :currency="this.currency"
                />
                <button
                    class="DeclarationAddItem"
                    :disabled="parcel.declaration && pageId == 3"
                    @click="
                        () => {
                            emit('close');
                            emit('declarationitems');
                        }
                    "
                >
                    ნივთის დამატება
                </button>

                <div class="DeclarationItemBlcoks">
                    <h2>ინვოისი</h2>

                    <div class="DeclarationItemBlcoksItem" v-if="file">
                        <div class="avatar">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8 12.2H15"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M8 16.2H12.38"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002"
                                    stroke="#fff"
                                    stroke-width="1.5"
                                    stroke-miterlimit="10"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </div>
                        <div class="name">
                            <p>ფაილი</p>
                            <span> {{ file.name }} </span>
                        </div>

                        <div class="spacer"></div>

                        <button
                            class="DeclarationItemDelete"
                            @click="FileDelete(file.id)"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                            >
                                <g id="trash" transform="translate(-108 -188)">
                                    <path
                                        id="Vector"
                                        d="M18,.5C14.67.17,11.32,0,7.98,0A59.068,59.068,0,0,0,2.04.3L0,.5"
                                        transform="translate(111 193.48)"
                                        fill="none"
                                        stroke="rgba(18,32,43,0.5)"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        id="Vector-2"
                                        data-name="Vector"
                                        d="M0,2.97.22,1.66C.38.71.5,0,2.19,0H4.81C6.5,0,6.63.75,6.78,1.67L7,2.97"
                                        transform="translate(116.5 190)"
                                        fill="none"
                                        stroke="rgba(18,32,43,0.5)"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        id="Vector-3"
                                        data-name="Vector"
                                        d="M13.7,0l-.65,10.07c-.11,1.57-.2,2.79-2.99,2.79H3.64C.85,12.86.76,11.64.65,10.07L0,0"
                                        transform="translate(113.15 197.14)"
                                        fill="none"
                                        stroke="rgba(18,32,43,0.5)"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        id="Vector-4"
                                        data-name="Vector"
                                        d="M0,0H3.33"
                                        transform="translate(118.33 204.5)"
                                        fill="none"
                                        stroke="rgba(18,32,43,0.5)"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        id="Vector-5"
                                        data-name="Vector"
                                        d="M0,0H5"
                                        transform="translate(117.5 200.5)"
                                        fill="none"
                                        stroke="rgba(18,32,43,0.5)"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                    />
                                    <path
                                        id="Vector-6"
                                        data-name="Vector"
                                        d="M0,0H24V24H0Z"
                                        transform="translate(108 188)"
                                        fill="none"
                                        opacity="0"
                                    />
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div
                        class="spinner-grow text-primary"
                        v-if="uploadLoader"
                        role="status"
                    >
                        <span class="visually-hidden">Loading...</span>
                    </div>

                    <label
                        for="fileUpload"
                        v-if="!uploadLoader"
                        class="file-upload-button"
                    >
                        <span> ინვოისი ატვირთვა </span>
                        <input
                            type="file"
                            id="fileUpload"
                            ref="onFile"
                            @input="FileChange"
                        />
                    </label>
                </div>

                <div class="calculator-inpout">
                    <input
                        name="comment"
                        class="w-100"
                        autocomplete="off"
                        type="text"
                        placeholder="კომენტარი"
                        v-model="comment"
                        :disabled="parcel.declaration && pageId == 3"
                    />
                </div>

                <div
                    class="form-check mb-5"
                    v-if="parcel.flight.country.repackaging"
                >
                    <input
                        class="form-check-input"
                        type="checkbox"
                        v-model="repackaging"
                        id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                        გადაფუთვა
                    </label>
                </div>

                <button @click="onSave" class="calculator-button">
                    დეკლარირება
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref, watch } from "@vue/composition-api";
import declarationItems from "./declarationItems.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useDeclaration } from "../../hooks/declaration";
import { useParcels } from "../../hooks/parcels";
import { Notyf } from "notyf";
import axios from "axios";
export default defineComponent({
    props: {
        parcel: {
            type: Object,
            default: null,
        },
        markets: {
            type: Array,
            default: [],
        },
        country: {
            type: Number,
            default: null,
        },
        currency: {
            type: Object,
            default: null,
        },
    },
    components: {
        declarationItems,
        ValidationObserver,
        ValidationProvider,
    },
    setup(props, { emit }) {
        const observer = ref(null);
        const onFile = ref(null);
        const uploadLoader = ref(false);
        const file = ref(
            props.parcel.file
                ? { name: props.parcel.file, id: props.parcel.id }
                : null
        );
        const {
            DeclarationItem,
            ParcelTypeInput,
            market,
            comment,
            parcelType,
            onSaveDeclaration,
            repackaging,
        } = useDeclaration();

        if (props.parcel.site_id) {
            market.value = props.parcel.site_id;
        }
        // market.value
        const { getParcels, pageId } = useParcels();
        // ---
        comment.value = props.parcel.comment;

        repackaging.value = props.parcel.repackaging;
        if (!parcelType.value) {
            parcelType.value = `1-${props.parcel.tracking_number}`;
        }

        if (props.parcel.parcel_type) {
            parcelType.value = `${props.parcel.parcel_type}-${props.parcel.tracking_number}`;
            ParcelTypeInput.value = props.parcel.parcel_type;
        }

        const notyf = new Notyf({
            duration: 3000,
            position: {
                x: "right",
                y: "top",
            },
        });

        const onSave = async () => {
            if (!(await observer.value.validate())) {
                return;
            }
            if (DeclarationItem.value.length == 0) {
                notyf.error("გთხოვთ დამატოთ ნივთი");
                return;
            }

            onSaveDeclaration({
                id: props.parcel.id,
                parcel_type: 1,
                site_id: market.value,
                comment: comment.value,
                declaration: true,
                repackaging: repackaging.value,
            }).then((e) => {
                onClose();
            });
        };
        const onClose = () => {
            getParcels(pageId.value);

            repackaging.value = true;
            comment.value = "";
            market.value = null;
            parcelType.value = null;
            ParcelTypeInput.value = 1;

            $(".markets").val("").trigger("change");
            emit("close");
        };

        const FileChange = () => {
            uploadLoader.value = true;
            if (onFile.value.files[0].size > 10241 * 10241) {
                notyf.error("ფაილის ზომა არავალიდურია 10MB ცდება");
                return;
            }
            let formData = new FormData();
            formData.append("file", onFile.value.files[0]);
            formData.append("id", props.parcel.id);
            axios({
                method: "post",
                url: "/api/declaration/fileUpload",
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((e) => {
                file.value = e.data;
                uploadLoader.value = false;
            });
        };
        const FileDelete = (id) => {
            let formData = new FormData();
            formData.append("id", id);
            axios({
                method: "post",
                url: "/api/declaration/fileDelete",
                data: formData,
            }).then((e) => {
                file.value = null;
            });
        };

        watch(
            () => parcelType.value,
            (newVal) => {
                let inputVal = newVal.split("-");
                ParcelTypeInput.value = inputVal[0];
            }
        );

        onMounted(() => {
            $(".markets")
                .select2({
                    placeholder: "აირჩიე მაღაზია",
                })
                .on("select2:select", (e) => {
                    market.value = Number(e.params.data.id);
                });

            if (props.parcel.site_id) {
                $(".markets").val(props.parcel.site_id).trigger("change");
            }
        });

        return {
            props,
            emit,
            parcelType,
            comment,
            market,
            ParcelTypeInput,
            onSave,
            onClose,
            observer,
            pageId,
            onFile,
            FileChange,
            file,
            FileDelete,
            uploadLoader,
            repackaging,
        };
    },
});
</script>
